document.addEventListener("DOMContentLoaded", function () {
  const builder = document.getElementById("CoffeePlanBuilder");
  if (!builder) return;

  const dataElement = document.getElementById("coffee-plan-data");
  if (!dataElement) return;

  let coffeeData;
  try {
    coffeeData = JSON.parse(dataElement.textContent);
  } catch (error) {
    console.error("Coffee plan builder: invalid coffee data", error);
    return;
  }

  const frequencySelect = document.getElementById("coffee-frequency");
  const coffeeSelect = document.getElementById("coffee-selection");
  const packSelect = document.getElementById("coffee-pack-size") || document.getElementById("pack-size");
  const bagsSelect = document.getElementById("bags-per-delivery");
  const grindSelect = document.getElementById("coffee-grind") || document.getElementById("grind-selection");
  const mixContainer = document.getElementById("mix-coffees");
  const deliveryContainer = document.getElementById("delivery-selectors");
  const summary = document.getElementById("summary-content");
  const addButton = document.getElementById("coffee-plan-add");
  if (addButton) addButton.type = "button";
  const message = document.getElementById("coffee-plan-message");

  if (
  !frequencySelect ||
  !coffeeSelect ||
  !packSelect ||
  !bagsSelect ||
  !grindSelect ||
  !mixContainer ||
  !deliveryContainer ||
  !summary
) {
  console.error("Coffee plan builder: required element missing.");
  return;
}


  const deliveryCount = Number(builder.dataset.deliveryCount) ||
    parseInt((builder.dataset.plan || "").match(/\d+/)?.[0], 10) || 3;

  const discountRate = Math.max(0, Number(builder.dataset.discountRate) ||
    (deliveryCount === 3 ? 0.10 : deliveryCount === 6 ? 0.15 : 0));

  function formatMoney(cents) {
    return (Number(cents || 0) / 100).toLocaleString("en-IN", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function showMessage(text, isError = true) {
    if (!message) return;
    message.textContent = text || "";
    message.classList.toggle("is-error", isError);
  }

  function clearMessage() {
    showMessage("", false);
  }

  function getCoffeeTitle(handle) {
    return handle && coffeeData[handle] ? coffeeData[handle].title : "";
  }

  // Subscription builder only supports 250 gm and 1 Kg.
  // Retail-only sizes such as 100 gm must never appear here.
  function updatePackSizes() {
    const current = packSelect.value;
    const allowedSizes = ["250 gm", "1 Kg"];
    const sizes = [];

    Object.values(coffeeData).forEach(function (coffee) {
      (coffee.variants || []).forEach(function (variant) {
        const size = variant.options?.[1];
        if (size && allowedSizes.includes(size) && !sizes.includes(size)) {
          sizes.push(size);
        }
      });
    });

    // Keep the intended display order even if the collection/variant order changes.
    sizes.sort(function (a, b) {
      return allowedSizes.indexOf(a) - allowedSizes.indexOf(b);
    });

    packSelect.innerHTML = '<option value="">Select pack size</option>';
    sizes.forEach(function (size) {
      const option = document.createElement("option");
      option.value = size;
      option.textContent = size;
      packSelect.appendChild(option);
    });

    if (sizes.includes(current)) packSelect.value = current;
  }

  function updateGrinds() {
    const current = grindSelect.value;
    grindSelect.innerHTML = '<option value="">Select your grind</option>';

    const selectedHandle = coffeeSelect.value;
    const coffees = selectedHandle === "mix"
      ? Object.values(coffeeData)
      : selectedHandle && coffeeData[selectedHandle]
        ? [coffeeData[selectedHandle]]
        : [];

    const grinds = [];
    coffees.forEach(function (coffee) {
      (coffee.variants || []).forEach(function (variant) {
        const grind = variant.options?.[0];
        if (grind && !grinds.includes(grind)) grinds.push(grind);
      });
    });

    grinds.forEach(function (grind) {
      const option = document.createElement("option");
      option.value = grind;
      option.textContent = grind;
      grindSelect.appendChild(option);
    });

    if (grinds.includes(current)) grindSelect.value = current;
  }

  function findVariant(coffeeHandle, packSize, grind) {
    const coffee = coffeeData[coffeeHandle];
    if (!coffee) return null;

    return (coffee.variants || []).find(function (variant) {
      return variant.options?.[0] === grind && variant.options?.[1] === packSize;
    }) || null;
  }

  function getDeliveryCoffees() {
    if (coffeeSelect.value === "mix") {
      return Array.from(deliveryContainer.querySelectorAll("select"), select => select.value);
    }
    return Array.from({ length: deliveryCount }, () => coffeeSelect.value);
  }

  function calculatePlan() {
    const packSize = packSelect.value;
    const grind = grindSelect.value;
    const bags = parseInt(bagsSelect.value, 10) || 1;
    const deliveries = getDeliveryCoffees();

    let regularTotal = 0;
    let valid = Boolean(packSize && grind && deliveries.length === deliveryCount);

    deliveries.forEach(function (coffeeHandle) {
      if (!coffeeHandle) {
        valid = false;
        return;
      }
      const variant = findVariant(coffeeHandle, packSize, grind);
      if (!variant || variant.available === false) {
        valid = false;
        return;
      }
      regularTotal += Number(variant.price) * bags;
    });

    const savings = Math.round(regularTotal * discountRate);
    const total = regularTotal - savings;
    return { packSize, grind, bags, deliveries, regularTotal, savings, total, valid };
  }

  function getFrequencyText() {
    return frequencySelect.value === "twice" ? "Twice a month" : "Once a month";
  }

  function getDurationText() {
    const duration = frequencySelect.value === "twice" ? deliveryCount / 2 : deliveryCount;
    return `${duration} months`;
  }

  function updateSummary() {
    const plan = calculatePlan();
    let html = `<p><strong>${deliveryCount} Deliveries</strong></p>`;
    html += `<p>Frequency: ${getFrequencyText()}</p>`;
    html += `<p>Subscription duration: ${getDurationText()}</p>`;
    html += `<p>Coffee: ${coffeeSelect.value === "mix" ? "Mix My Coffees" : (getCoffeeTitle(coffeeSelect.value) || "Not selected")}</p>`;
    html += `<p>Pack size: ${plan.packSize || "Not selected"}</p>`;
    html += `<p>Bags per delivery: ${plan.bags}</p>`;
    html += `<p>Grind: ${plan.grind || "Not selected"}</p>`;
    html += `<h3>Your Deliveries</h3>`;

    plan.deliveries.forEach(function (coffeeHandle, index) {
      html += `<div class="summary-delivery"><span>Delivery ${index + 1}: </span><span>${getCoffeeTitle(coffeeHandle) || " Not selected"} × ${plan.bags}</span></div>`;
    });

    if (plan.regularTotal > 0) {
  html += `
    <div class="coffee-plan-pricing" style="
      margin-top: 18px;
      padding-top: 14px;
      border-top: 1px solid currentColor;
    ">
      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 6px;
        font-size: 15px;
        line-height: 1.3;
      ">
        <span>Regular price:</span>
        <span>₹${formatMoney(plan.regularTotal)}</span>
      </div>

      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 12px;
        font-size: 15px;
        line-height: 1.3;
      ">
        <span>You save:</span>
        <span>₹${formatMoney(plan.savings)} (${discountRate * 100}%)</span>
      </div>

      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0;
        padding: 14px 18px;
        border: 2px solid currentColor;
        font-weight: 700;
      ">
        <span style="
          font-size: 13px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          font-weight: 700;
        ">
          TOTAL AMOUNT
        </span>

        <span style="
          font-size: 30px;
          line-height: 1;
          font-weight: 800;
          white-space: nowrap;
        ">
          ₹${formatMoney(plan.total)}
        </span>
      </div>
    </div>
  `;
}

    summary.innerHTML = html;
    clearMessage();
  }

  function createDeliverySelectors() {
    deliveryContainer.innerHTML = "";

    for (let i = 1; i <= deliveryCount; i++) {
      const wrapper = document.createElement("div");
      wrapper.className = "delivery-selector";

      const label = document.createElement("label");
      label.textContent = `Delivery ${i}`;

      const select = document.createElement("select");
      const placeholder = document.createElement("option");
      placeholder.value = "";
      placeholder.textContent = "Select coffee";
      select.appendChild(placeholder);

      Object.entries(coffeeData).forEach(function ([handle, coffee]) {
        const option = document.createElement("option");
        option.value = handle;
        option.textContent = coffee.title;
        select.appendChild(option);
      });

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      deliveryContainer.appendChild(wrapper);
      select.addEventListener("change", updateSummary);
    }
  }

  function validatePlan(plan) {
    if (!coffeeSelect.value) return "Please choose your coffee.";
    if (!plan.packSize) return "Please choose your pack size.";
    if (!plan.grind) return "Please choose your grind.";
    if (plan.deliveries.some(handle => !handle)) return "Please choose a coffee for every delivery.";

    const unavailable = plan.deliveries.find(handle => !findVariant(handle, plan.packSize, plan.grind) || findVariant(handle, plan.packSize, plan.grind).available === false);
    if (unavailable) return `The selected grind/pack combination is unavailable for ${getCoffeeTitle(unavailable)}.`;
    return null;
  }

  async function loadPlanVariants() {
    const embedded = document.getElementById("coffee-plan-variants");
    if (embedded) {
      try {
        const variants = JSON.parse(embedded.textContent || "[]");
        if (Array.isArray(variants) && variants.length) return variants;
      } catch (error) {
        console.warn("Invalid embedded plan variant data", error);
      }
    }

    const handle = builder.dataset.plan;
    if (!handle) throw new Error("The plan product handle is missing.");

    const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: "application/json" },
      cache: "no-store"
    });
    if (!response.ok) throw new Error("Unable to load the plan pricing variants.");
    const product = await response.json();
    return product.variants || [];
  }

  function findPriceVariant(variants, total) {
    const target = Number(total);
    return (variants || []).find(function (variant) {
      return Number(variant.price) === target && variant.available !== false;
    }) || null;
  }

  async function addPlanToCart(event) {
    event.preventDefault();
    clearMessage();

    const plan = calculatePlan();
    const validationError = validatePlan(plan);
    if (validationError) {
      showMessage(validationError);
      return;
    }

    addButton.disabled = true;
    addButton.dataset.originalText = addButton.dataset.originalText || addButton.textContent;
    addButton.textContent = "Adding…";

    const properties = {
      "Plan": `${deliveryCount} Deliveries`,
      "Subscription ID": `SUB-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      "Frequency": getFrequencyText(),
      "Subscription duration": getDurationText(),
      "Pack size": plan.packSize,
      "Bags per delivery": String(plan.bags),
      "Grind": plan.grind,
      "Calculated subscription total": `₹${formatMoney(plan.total)}`,
      "Regular price": `₹${formatMoney(plan.regularTotal)}`,
      "Savings": `₹${formatMoney(plan.savings)} (${discountRate * 100}%)`
    };

    plan.deliveries.forEach(function (coffeeHandle, index) {
      properties[`Delivery ${index + 1}`] = getCoffeeTitle(coffeeHandle);
    });

    try {
      const variants = await loadPlanVariants();
      const matchingVariant = findPriceVariant(variants, plan.total);

      if (!matchingVariant) {
        throw new Error(`No available price variant exists for ₹${formatMoney(plan.total)} on this ${deliveryCount}-delivery plan. The plan has not been added to your cart.`);
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(matchingVariant.id), quantity: 1, properties }]
        })
      });

      if (!response.ok) {
        let detail = "";
        try {
          const errorJson = await response.json();
          detail = errorJson.description || errorJson.message || "";
        } catch (_) {}
        throw new Error(detail || "Unable to add the coffee plan to the cart.");
      }

      await response.json();
      window.location.href = "/cart";
    } catch (error) {
      console.error("Coffee plan add-to-cart error", error);
      showMessage(error.message || "There was a problem adding your coffee plan to the cart.");
      addButton.disabled = false;
      addButton.textContent = addButton.dataset.originalText || "Add to Cart";
    }
  }

  coffeeSelect.addEventListener("change", function () {
    if (coffeeSelect.value === "mix") {
      mixContainer.hidden = false;
      createDeliverySelectors();
    } else {
      mixContainer.hidden = true;
      deliveryContainer.innerHTML = "";
    }
    updateGrinds();
    updateSummary();
  });

  frequencySelect.addEventListener("change", updateSummary);
  packSelect.addEventListener("change", updateSummary);
  bagsSelect.addEventListener("change", updateSummary);
  grindSelect.addEventListener("change", updateSummary);
  if (addButton) {
    // This element is intentionally NOT a native <button> or product-form submit control.
    // Keep the interaction self-contained so theme product-form scripts cannot add the
    // default plan variant.
    addButton.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      addPlanToCart(event);
    });

    addButton.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        addPlanToCart(event);
      }
    });
  }

  updatePackSizes();
  updateGrinds();
  updateSummary();
});
